/* ThemedFallback - Gradient/bar fallback for missing images */

.fallback {
  /* The client hero's missing-photo recipe (BookingHero .heroFallback): a quiet
     glass-to-page fade in the studio's look, never a solid accent block. */
  background: linear-gradient(135deg, var(--glass-bg-strong, var(--color-accent)) 0%, var(--bg-page, var(--color-accent-dark)) 100%);
}

/* Event type: Full card background gradient */
.event {
  width: 100%;
  height: 100%;
}

/* Service type: Short decorative bar at top of card */
.service {
  width: 100%;
  height: 24px;
  /* Horizontal gradient for bar variation */
  background: linear-gradient(90deg, var(--accent, var(--color-accent)) 0%, var(--accent-light, var(--color-accent-light)) 100%);
}
